//
//
import {
  call,
  put,
  takeEvery,
  take,
  select,
  takeLatest,
} from "redux-saga/effects"

import {
  CARGOS_GET_COSTO_INSCRIPCION,
  CARGOS_GET_COSTO_COLEGIATURA,
} from "./actionTypes"

import {
  getCargosCostoInscripcionSuccess,
  getCargosCostoInscripcionFail,
  getCargosCostoColegiaturaSuccess,
  getCargosCostoColegiaturaFail,
} from "./actions"

import { get_From_CargosController } from "../../helpers/campusvirtualbackend_helper"

function* fetchCostoInscripcion({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CargosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCargosCostoInscripcionFail(response.Mensaje_Detalle))
    } else {
      yield put(getCargosCostoInscripcionSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCargosCostoInscripcionFail(error))
  }
}

function* fetchCostoColegiatura({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_CargosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getCargosCostoColegiaturaFail(response.Mensaje_Detalle))
    } else {
      yield put(getCargosCostoColegiaturaSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getCargosCostoColegiaturaFail(error))
  }
}

function* CargosSaga() {
  yield takeLatest(CARGOS_GET_COSTO_INSCRIPCION, fetchCostoInscripcion)
  yield takeLatest(CARGOS_GET_COSTO_COLEGIATURA, fetchCostoColegiatura)
}

export default CargosSaga
